/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { s3Base } from "./constants/Endpoint";

const s3BaseUrl = s3Base;
const dashboardStaticImageBaseUrl = s3BaseUrl + "dashboard-static-image/"

export const getDashboardImageUrl = (imageName, extension = "png") => {
  return `${dashboardStaticImageBaseUrl}${imageName}.${extension}`;
};
